module.exports = __webpack_public_path__ + "static/media/yungkev.77a548b2.jpg";